import { Typography } from "antd";

const { Paragraph, Title } = Typography;
const PrivacyPolicy = () => {
  return (
    <div className="my-8">
      <Title level={3}>Privacy Policy</Title>
      <Paragraph className="text-left my-8 px-16 max-sm:px-4">
        <p>
          We, Alpshop, are registered at Plot No. 32,Sector-18 HUDA,
          Gurgaon-122015(Haryana),INDIA. At Alpshop , we respect your privacy &
          value your trust. This Privacy Policy provides you with details about
          the manner in which your data is collected, stored & used by us. You
          are advised to read this policy carefully. After going through below
          details, you expressly give us consent to use & disclose your personal
          information in accordance with this Privacy Policy. If you do not
          agree to the terms of the policy, please do not use or access Alpshop
          website and mobile applications. Note: Request you to kindly review
          the policy periodically since it can change without any prior
          notification. The privacy policy shall apply to both Alpshop website
          and mobile applications.
        </p>
        <p>
          In terms of the Information Technology (Intermediaries Guidelines)
          Rules, 2011 and the Information Technology (Reasonable Security
          Practices and Procedures and Sensitive Personal Data or Information)
          Rules, 2011, any grievance or complaint may be intimated to Grievance
          Officer, who may be reached at Plot No. 32,Sector-18 HUDA,
          Gurgaon-122015(Haryana),INDIA. The complaint shall be redressed within
          a period of 1 (one) month.
        </p>
        <Title level={5}>General</Title>
        <p>
          We do not sell or rent individual customer names or other Personal
          Information to third parties except sharing of such information with
          partners or vendors who are engaged by us for providing car services
          or accessories from time to time. Any emails and/or SMS sent by
          GoMechanic will only be in connection with the provision of agreed
          services & products and this Privacy Policy. In case we receive
          legally-compliant request to disclose your personal information, then
          we reserve the right to do so.
        </p>
        <Title level={5}>Personal Information</Title>
        <p>
          In connection to the services offered by Alpshop, personal information
          means and includes all information that can be linked to specific
          individual or to identify any individual, such as name, mobile number,
          email-id, credit card number, debit card number, card holder name,
          expiration date, account details that may have been provided by user
          to access the services. While browsing the Alpshop website, it may
          collect information regarding Internet Protocol (IP) address of
          computer, Internet Service Provider (ISP) you are using and anonymous
          statistical data.
        </p>
        <Title level={5}>Using Personal Information</Title>
        <p>
          Alpshop uses the information provided by you to share offers based on
          your interest, location and past history. These offers help you save
          your money and experience great service. GoMechanic also uses this
          information to provide you services you requested for, to troubleshoot
          issues you may come across while using our service, to resolve
          disputes, to customize your experience, to communicate with you
          updates, detect & protect us against error, fraud and other criminal
          activity, enforce our terms and conditions, etc.
        </p>
        <Title level={5}>Cookies</Title>
        <p>
          A "cookie" is a small piece of information stored by a web server on a
          web browser so it can be later read back from that browser. Alpshop
          uses cookie and tracking technology depending on the features offered.
          No personal information will be collected via cookies and other
          tracking technology.
        </p>
        <Title level={5}>WhatsApp Communication</Title>
        <p>
          We give our consent to receive transactional communications from
          Alpshop over WhatsApp channel on booking order through app and
          website.
        </p>
        <Title level={5}>Security</Title>
        <p>
          Alpshop has stringent security measures in place to protect the loss,
          misuse and alteration of the information under its control. Once your
          information is in GoMechanic's possession it adheres to strict
          security guidelines, protecting it against unauthorized access.
        </p>
      </Paragraph>
    </div>
  );
};
export default PrivacyPolicy;
